export default __webpack_public_path__ + "static/gero-671543d9c36653d1426d27f6efb961e6.png";